import { render, staticRenderFns } from "./details_dossier.vue?vue&type=template&id=332db958&scoped=true"
import script from "./details_dossier.vue?vue&type=script&lang=js"
export * from "./details_dossier.vue?vue&type=script&lang=js"
import style0 from "./details_dossier.vue?vue&type=style&index=0&id=332db958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332db958",
  null
  
)

export default component.exports